import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';

import { LoginWidgetComponent, LoginWidgetContext } from '@fcom/common/login';
import { LoginStatus } from '@fcom/core-api/login';

@Component({
  selector: 'fin-timetable-routing',
  templateUrl: './timetable-routing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimetableRoutingComponent {
  @ViewChild('loginWidget', { static: true }) loginWidget: LoginWidgetComponent;

  public readonly LoginWidgetContext = LoginWidgetContext;
  public readonly LoginStatus = LoginStatus;
}
